import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import {
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import { satc_periods } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import { useTranslation } from "react-i18next";
import showNotify from "Helpers/Notify";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";
import addNumToList from "Helpers/addNumToList";
import { useTheme } from "@material-ui/core/styles";
import DialogHead from "Components/DialogHead/DialogHead";

export default function Periods({ row }) {
  const { direction } = useTheme();
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = () => {
    const params = {
      KeyGroup: read("groupAKey"),
      KeyUser: read("userAKey"),
      Limit: sizePerPage,
      Page: 1,
      GroupId: row.Id,
    };
    caller(params);
  };

  const onExit = () => {
    setShowDialog(false);
  };

  const onTableChange = (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: sizePerPage,
        Page: page,
        GroupId: row.Id,
      };
      caller(params);
    }
  };

  const caller = async (params) => {
    try {
      setLoading(true);
      const response = await AccountService.getAccountGroupHistory(params);
      let err = StatusHandler(response);
      // console.log(response);
      // console.log(params);
      if (!err.isFail) {
        setData(
          addNumToList(response.data.Value, params.Page, params.Limit, {
            GroupName: row.Name,
          })
        );
        setPagination(response.data.Pagination);
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (e) {
      showNotify({ text: "getDataError", customClass: "error" });
      setShowDialog(false);
    }
  };

  const setPagination = (pagination) => {
    setSizePerPage(pagination.Limit);
    setCurrentPage(pagination.Page);
    setTotal(pagination.Total);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="periods" />}
        icon={<Icons.Calendar2Week />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        fullWidth
        maxWidth="lg"
      >
        <DialogHead
          text={<Translator id="periods" />}
          subtext={row.Name}
          icon={<Icons.Calendar2Week />}
        />
        <DialogContent className="p-0 py-2">
          {loading ? (
            <InnerCircularProgress />
          ) : (
            <RemoteTable
              data={data}
              columns={satc_periods}
              loading={loading}
              page={currentPage}
              sizePerPage={sizePerPage}
              totalSize={total}
              onTableChange={onTableChange}
              noTitle={true}
              hideBorderTop={true}
            />
          )}
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={() => setShowDialog(false)}
            title={<Translator id="close" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
